var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRepaymentSchedule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 16C4.67267 16 4 15.3273 4 14.5V6.5C4 5.67267 4.67267 5 5.5 5H7V4.5C7 4.224 7.224 4 7.5 4C7.776 4 8 4.224 8 4.5V5H12V4.5C12 4.224 12.224 4 12.5 4C12.776 4 13 4.224 13 4.5V5H14.5C15.3273 5 16 5.67267 16 6.5V9.5C16 9.776 15.776 10 15.5 10C15.224 10 15 9.776 15 9.5V9H5V14.5C5 14.776 5.224 15 5.5 15H9.5C9.776 15 10 15.224 10 15.5C10 15.776 9.776 16 9.5 16H5.5ZM15 8V6.5C15 6.224 14.776 6 14.5 6H13V6.5C13 6.776 12.776 7 12.5 7C12.224 7 12 6.776 12 6.5V6H8V6.5C8 6.776 7.776 7 7.5 7C7.224 7 7 6.776 7 6.5V6H5.5C5.224 6 5 6.224 5 6.5V8H15Z",
    fill: "#FF884E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 20C13.0187 20 11 17.9813 11 15.5C11 13.0187 13.0187 11 15.5 11C17.9813 11 20 13.0187 20 15.5C20 17.9813 17.9813 20 15.5 20ZM15.5 12C13.57 12 12 13.57 12 15.5C12 17.43 13.57 19 15.5 19C17.43 19 19 17.43 19 15.5C19 13.57 17.43 12 15.5 12Z",
    fill: "#FF884E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 18C15.224 18 15 17.776 15 17.5V16H13.5C13.224 16 13 15.776 13 15.5C13 15.224 13.224 15 13.5 15H15V13.5C15 13.224 15.224 13 15.5 13C15.776 13 16 13.224 16 13.5V15H17.5C17.776 15 18 15.224 18 15.5C18 15.776 17.776 16 17.5 16H16V17.5C16 17.776 15.776 18 15.5 18Z",
    fill: "#FF884E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepaymentSchedule);
export default __webpack_public_path__ + "static/media/repayment-schedule.d77dbfc5.svg";
export { ForwardRef as ReactComponent };